var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f6f4b7fda800e98f70fc4e93d1c981582b77a073"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["zcm-site@zentrum-fur-cannabismedizin"]={id:"f6f4b7fda800e98f70fc4e93d1c981582b77a073"};
      